import { render, staticRenderFns } from "./GPE4M_GP4AT_money_records.vue?vue&type=template&id=a415638e&scoped=true&"
import script from "./GPE4M_GP4AT_money_records.vue?vue&type=script&lang=js&"
export * from "./GPE4M_GP4AT_money_records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a415638e",
  null
  
)

export default component.exports